// Imported first by src/index.js: uncaught errors are recorded from the start, including a
// failed startup (feature flags) that happens before the app renders.
import { installGlobalErrorHandlers } from '.';

installGlobalErrorHandlers();
